module.exports = __webpack_public_path__ + "static/media/bot.5688a78c.JPG";